import { Component } from '@angular/core';

@Component({
  selector: 'wchfs-top-actions-bar',
  templateUrl: './top-actions-bar.component.html',
  styleUrls: ['./top-actions-bar.component.scss'],
})
export class TopActionsBarComponent {}
